import angular from 'angular';
import uirouter from 'angular-ui-router';

import uibs from 'angular-ui-bootstrap';

import states from './states';
import nav from './nav';
import data from './data';

import tmContractsCtrl from './contracts/tmContractsCtrl';
import tmContractsPendingCtrl from './contractsPending/tmContractsPendingCtrl';
import tmVenuesCtrl from './venues/tmVenuesCtrl';
import tmRentalItemsCtrl from './rentalitems/tmRentalItemsCtrl';

import tmContractDocSvc from './contracts/tmContractDocSvc';
import tmRentalItemDocSvc from './rentalitems/tmRentalItemDocSvc';
import tmStaffMembersDocSvc from './staffMembers/tmStaffMembersDocSvc';
import tmVenueDocSvc from './venues/tmVenueDocSvc';

import tmContractDetailCtrl from './contracts/tmContractDetailCtrl';
import tmContractPrintCtrl from './contracts/tmContractPrintCtrl';
import tmRentalItemDetailCtrl from './rentalitems/tmRentalItemDetailCtrl';
import tmStaffMembersCtrl from './staffMembers/tmStaffMembersCtrl';
import tmStaffMembersDetailCtrl from './staffMembers/tmStaffMembersDetailCtrl';
import tmVenueDetailCtrl from './venues/tmVenueDetailCtrl';
import tmAddContractCtrl from './contracts/tmAddContractCtrl';
// components
import tmDocGrid from './contracts/tabs/tmDocGrid.js';
import tmDocGridItem from './contracts/tabs/tmDocGridItem.js';


export default angular.module('events', [uirouter, uibs])

    .config(states)
    .config(nav)
    .config(data)
    .factory('tmContractDocSvc', tmContractDocSvc)
    .factory('tmRentalItemDocSvc', tmRentalItemDocSvc)
    .factory('tmStaffMembersDocSvc', tmStaffMembersDocSvc)
    .factory('tmVenueDocSvc', tmVenueDocSvc)
    .controller("tmContractsCtrl", tmContractsCtrl)
    .controller("tmContractsPendingCtrl", tmContractsPendingCtrl)
    .controller("tmVenuesCtrl", tmVenuesCtrl)
    .controller("tmRentalItemsCtrl", tmRentalItemsCtrl)
    .controller('tmContractDetailCtrl', tmContractDetailCtrl)
    .controller('tmContractPrintCtrl', tmContractPrintCtrl)
    .controller('tmRentalItemDetailCtrl', tmRentalItemDetailCtrl)
    .controller('tmStaffMembersCtrl', tmStaffMembersCtrl)
    .controller('tmStaffMembersDetailCtrl', tmStaffMembersDetailCtrl)
    .controller('tmAddContractCtrl', tmAddContractCtrl)
    .controller('tmVenueDetailCtrl', tmVenueDetailCtrl)
    .component('tmDocGrid', tmDocGrid)
    .component('tmDocGridItem', tmDocGridItem)
    .name;



// WEBPACK FOOTER //
// ./app/features/events/index.js